import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DetailedCustomer } from '../../models/customer.model';
import { MenuComponent } from '../menu/menu.component';

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss'],
  imports: [CommonModule, MenuComponent],
})
export class HeaderMenuComponent {
  @Input() menuOpen = false;
  @Input() shopHeader = false;
  @Input() customer: DetailedCustomer;
  @Output() menuOpenChange = new EventEmitter<boolean>();

  constructor() {}

  closeMenu(): void {
    this.menuOpen = false;
    this.menuOpenChange.emit(this.menuOpen);
  }

  menuChange(open: boolean) {
    this.menuOpen = open;
    this.menuOpenChange.emit(this.menuOpen);
  }
}
